/**
 * E-Signature Validation Schemas
 *
 * Zod validation schemas for e-signature forms.
 */

import {z} from 'zod';

/**
 * Password validation schema
 * - Required, non-empty
 */
export const passwordSchema = z.string().min(1, 'Password is required');

/**
 * MFA code validation schema
 * - Optional, 6 digits when provided
 */
export const mfaCodeSchema = z
  .string()
  .length(6, 'MFA code must be 6 digits')
  .regex(/^\d+$/, 'MFA code must be numeric')
  .optional()
  .or(z.literal(''));

/**
 * Reason validation schema
 * - Required, 1-1000 characters
 */
export const reasonSchema = z
  .string()
  .min(1, 'Reason is required')
  .max(1000, 'Reason must be less than 1000 characters');

/**
 * Complete signature form schema
 */
export const signatureFormSchema = z.object({
  password: passwordSchema,
  mfaCode: mfaCodeSchema,
  reason: reasonSchema,
});

export type SignatureFormData = z.infer<typeof signatureFormSchema>;

/**
 * Record field signature form schema
 * Same as base, but meaning comes from field config
 */
export const recordFieldSignatureSchema = signatureFormSchema;

export type RecordFieldSignatureFormData = z.infer<
  typeof recordFieldSignatureSchema
>;
